import { LevvySteps } from "./LevvySteps";
import { MakeSteps } from "./MakeSteps";
import { MondaySteps } from "./MondaySteps";
import { ZapierSteps } from "./ZapierSteps";
import { jsx as _jsx } from "react/jsx-runtime";
export function getIntegrationSteps(slug) {
  switch (slug) {
    case 'make':
      return /*#__PURE__*/_jsx(MakeSteps, {});
    case 'monday':
      return /*#__PURE__*/_jsx(MondaySteps, {});
    case 'zapier':
      return /*#__PURE__*/_jsx(ZapierSteps, {});
    case 'levvy':
      return /*#__PURE__*/_jsx(LevvySteps, {});
  }
}